export const LOGO_URL = "https://customer-assets-agu9un31.emergentagent.net/job_krishna-surat-props/artifacts/ao8fasw5_ChatGPT%20Image%20Aug%2029%2C%202026%2C%2002_31_22%20PM.png";

export const HERO_IMG = "https://images.unsplash.com/photo-1512453979798-5ea266f8880c?auto=format&fit=crop&w=1920&q=80";

export const CATEGORY_IMAGES = {
  residential: "https://images.unsplash.com/photo-1600585154340-be6161a56a0c?auto=format&fit=crop&w=800&q=80",
  commercial: "https://images.unsplash.com/photo-1497366216548-37526070297c?auto=format&fit=crop&w=800&q=80",
  industrial: "https://images.unsplash.com/photo-1553413077-190dd305871c?auto=format&fit=crop&w=800&q=80",
  plot: "https://images.unsplash.com/photo-1500382017468-9049fed747ef?auto=format&fit=crop&w=800&q=80",
  land: "https://images.unsplash.com/photo-1464822759023-fed622ff2c3b?auto=format&fit=crop&w=800&q=80",
};

export const LOCALITIES = ["Vesu","Adajan","Piplod","Athwa","City Light","Althan","Pal","Dumas","Bhatar","Varachha","Katargam","Udhna","Pandesara","Sachin","Kadodara","Hazira","Olpad","VIP Road","Amroli","Punagam","Limbayat","Majura"];

export const PROPERTY_TYPES = {
  residential: ["Apartment","Flat","Villa","Bungalow","House","Duplex","Penthouse"],
  commercial: ["Shop","Office","Showroom","Commercial Building","Business Space"],
  industrial: ["Factory","Industrial Shed","Industrial Land","GIDC Property"],
  warehouse: ["Warehouse","Cold Storage","Godown","Storage Unit","Logistics Park"],
  plot: ["Residential Plot","Corner Plot","Farm Land","NA Land","Agricultural Land"],
  land: ["Farm Land","NA Land","Agricultural Land","Commercial Land","Township Land"],
};

// 1 Gujarati Bigha (Surat region) ≈ 17,427 sq ft
export const SQFT_PER_BIGHA = 17427;

// Property types that are measured as land parcels — hide BHK / bath / floor,
// show Bigha conversion, and use land-specific amenities.
export const LAND_TYPES = new Set([
  "Industrial Land", "GIDC Property",
  "Residential Plot", "Corner Plot",
  "Farm Land", "NA Land", "Agricultural Land",
  "Commercial Land", "Township Land",
]);

export const isLandType = (category, propertyType) =>
  category === "plot" || category === "land" || LAND_TYPES.has(propertyType);

export const AMENITIES_BY_CATEGORY = {
  residential: ["Swimming Pool","Gym","24x7 Security","Power Backup","Lift","Clubhouse","Kids Play Area","Landscaped Garden","Modular Kitchen","CCTV","Reserved Parking","Water 24x7"],
  commercial: ["Reception","Conference Room","Cafeteria","Lift","Central AC","Power Backup","24x7 Security","CCTV","Reserved Parking","Fire Safety","High-speed Internet","Visitor Parking"],
  industrial: ["3-Phase Power","Fire Safety","CCTV","Loading Bay","Overhead Crane","Water Storage","Effluent Treatment","24x7 Security","Wide Approach Road","GIDC Approved"],
  warehouse: ["Loading Bay","Dock Access","24x7 Security","CCTV","Fire Safety","Power Backup","Water Storage","Wide Approach Road","High Ceiling"],
  land: ["Boundary Wall","Tar Road Access","Water Connection","Electricity Connection","Corner Location","Gated Area","Clear Title","RERA Approved","Near Highway","Fenced","Bore Well","Irrigation Available"],
  plot: ["Boundary Wall","Tar Road Access","Water Connection","Electricity Connection","Corner Plot","Gated Community","Clear Title","RERA Approved","Near Highway","Park-facing","East-facing","North-facing"],
};

export const CONTACT = {
  phone: "+91 94281 25078",
  phoneRaw: "919428125078",
  email: "info@krishnaproperty.org",
  address: "Surat, Gujarat, India",
  whatsapp: "9428125078",
  whatsappUrl: "https://wa.me/9428125078",
  instagramUrl: "https://www.instagram.com/krishna_property_surat?utm_source=qr&igsi=a2pvbnlqNnA4ZW5i",
  facebookUrl: "https://www.facebook.com/share/1d84KncMbV/",
};
